(function() {
  let APICredentialForm = function() {
    this.$authenticationType = $('[data-authentication-type]');
    this.$environment = $('[data-environment]');
    this.$warning = $('[data-warning]');
    this.$restrictedAccess = $('[data-restricted-access]');
    this.$enabled= $('[data-enabled]')
  };

  APICredentialForm.prototype.init = function() {
    this.$environment.on('change', this.handleEnvironmentChange.bind(this));
    this.toggleAuthenticationType(this.$environment.val());
    this.$restrictedAccess.on('change', this.disableIfRestrictedAccess.bind(this)).trigger('change');
  };

  APICredentialForm.prototype.handleEnvironmentChange = function(event) {
    event.preventDefault();
    this.toggleAuthenticationType(event.target.value);
  };

  APICredentialForm.prototype.toggleAuthenticationType = function(environment) {
    if (environment === 'production') {
      this.hideAuthenticationType();
    } else {
      this.showAuthenticationType();
    }
  };

  APICredentialForm.prototype.hideAuthenticationType = function() {
    this.$authenticationType.select2().val('jwt').trigger('change');
    this.$authenticationType.parents('.form-row').hide();
    this.$warning.show();
  };

  APICredentialForm.prototype.showAuthenticationType = function() {
    this.$authenticationType.parents('.form-row').show();
    this.$warning.hide();
  };

  APICredentialForm.prototype.disableIfRestrictedAccess = function(event) {
    if (event.target.checked) {
      this.$enabled.prop('checked', false);
    }
  };

  window.APICredentialForm = APICredentialForm;
})();
